import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function DownloadIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 16 17" htmlColor={Color.Body} {...props}>
      <path d="M8.01 11a.55.55 0 0 1-.422-.17L5.515 8.755a.47.47 0 0 1-.147-.348.5.5 0 0 1 .147-.355.5.5 0 0 1 .356-.16.47.47 0 0 1 .357.15L7.51 9.325v-5.1q0-.213.143-.356a.48.48 0 0 1 .357-.144q.213 0 .356.144a.48.48 0 0 1 .144.356v5.1l1.282-1.282a.48.48 0 0 1 .353-.147.5.5 0 0 1 .36.157q.144.155.15.352a.47.47 0 0 1-.15.351l-2.073 2.073a.55.55 0 0 1-.422.17Zm-3.795 2.725q-.506 0-.855-.35a1.16 1.16 0 0 1-.35-.855v-1.308q0-.212.143-.356a.48.48 0 0 1 .357-.144q.212 0 .356.144a.48.48 0 0 1 .144.356v1.308q0 .076.064.141.065.064.14.064h7.59a.2.2 0 0 0 .142-.064.2.2 0 0 0 .064-.14v-1.309q0-.212.143-.356a.48.48 0 0 1 .357-.144q.212 0 .356.144a.48.48 0 0 1 .144.356v1.308q0 .506-.35.855-.351.35-.855.35z" />
    </MuiSvgIcon>
  );
}
export default DownloadIcon;
